import { IRoute, IRouteType } from "App/types";
import { lazy } from "react";
import {
  SearchPage,
  VenuePage,
  CreateVenuePage,
  DashboardPage,
  CreateStagePage,
  EditVenueBrandingPage,
  EditVenuePage,
  EditVenueEquipmentPage,
  EditEquipmentBlockPage,
  EditVenueInfoBlock,
  EditStageInfoBlock,
} from "Venues/pages";
import { PATHS } from "App/router";
import { VENUE_PATHS } from "Venues/router";
import StagePage from "Venues/pages/stage/Stage";
import EditStagePage from "Venues/pages/edit-stage/EditStage";
import { IPermissionKey } from "shared/types";

const VenuePageRouter = lazy(() => import("./VenuePageRouter"));
const StagePageRouter = lazy(() => import("./StagePageRouter"));

export const venueRoutes: IRoute[] = [
  {
    Component: SearchPage,
    path: PATHS.HOME,
    exact: true,
  },
  {
    Component: DashboardPage,
    path: PATHS.DASHBOARD,
    exact: true,
    type: IRouteType.private,
  },
  {
    Component: CreateVenuePage,
    path: VENUE_PATHS.CREATE_VENUE,
    exact: true,
    type: IRouteType.private,
  },
  {
    Component: VenuePageRouter,
    path: VENUE_PATHS.VENUE_PAGE_ROUTER,
  },
];

export const venuePageRoutes: IRoute[] = [
  // VENUE_PATHS.CREATE_VENUE and VENUE_PATHS.CREATE_VENUE_STAGE route should come before VENUE_PATHS.VENUE
  {
    Component: CreateStagePage,
    path: VENUE_PATHS.CREATE_VENUE_STAGE,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  {
    Component: EditVenuePage,
    path: VENUE_PATHS.EDIT_VENUE,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  {
    Component: EditVenueBrandingPage,
    path: VENUE_PATHS.EDIT_VENUE_BRANDING,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  {
    Component: EditVenueEquipmentPage,
    path: VENUE_PATHS.EDIT_VENUE_EQUIPMENT,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  // VENUE_PATHS.EDIT_VENUE_INFO_BLOCK must be before all other edit venue routes (such as VENUE_PATHS.EDIT_VENUE_EQUIPMENT and VENUE_PATHS.EDIT_VENUE_BRANDING)
  {
    Component: EditVenueInfoBlock,
    path: VENUE_PATHS.EDIT_VENUE_INFO_BLOCK,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  {
    Component: StagePageRouter,
    path: VENUE_PATHS.STAGE_PAGE_ROUTER,
  },
  {
    Component: VenuePage,
    path: VENUE_PATHS.VENUE,
    exact: true,
  },
];

export const stagePageRoutes: IRoute[] = [
  {
    Component: StagePage,
    path: VENUE_PATHS.STAGE,
    exact: true,
  },
  {
    Component: EditStagePage,
    path: VENUE_PATHS.EDIT_STAGE,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  {
    Component: EditEquipmentBlockPage,
    path: VENUE_PATHS.EDIT_STAGE_EQUIPMENT,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
  {
    Component: EditStageInfoBlock,
    path: VENUE_PATHS.EDIT_STAGE_INFO_BLOCK,
    exact: true,
    type: IRouteType.permission,
    permissionType: IPermissionKey.edit,
  },
];
